module.exports = __webpack_public_path__ + "media/veracruz/ActividadEcocultural-d6739f9e.png";